import { render } from "./NormasSetoriais.vue?vue&type=template&id=5b251375&scoped=true"
import script from "./NormasSetoriais.vue?vue&type=script&lang=js"
export * from "./NormasSetoriais.vue?vue&type=script&lang=js"

import "./NormasSetoriais.vue?vue&type=style&index=0&id=5b251375&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b251375"]])

export default __exports__